/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Video_Requires_Mixdown_ShortInputs */



/**
* | output |
* | --- |
* | "Requires Mixdown" |
*
* @param {Audio_Description_Export_Video_Requires_Mixdown_ShortInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_video_requires_mixdown_short = /** @type {((inputs?: Audio_Description_Export_Video_Requires_Mixdown_ShortInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Video_Requires_Mixdown_ShortInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mixdown requis")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mixdown erforderlich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Richiede Mixdown")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Требуется сведение.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Requiere mezcla")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("需要混音")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ミックスダウンが必要")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मिक्सडाउन आवश्यक है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Requer Mixdown")
	return /** @type {LocalizedString} */ ("Requires Mixdown")
});